import mqtt from 'mqtt'
import Vue from 'vue'
import store from '../store'

import {
  Notification
} from 'element-ui'
import {
  randomString
} from '../util/util'

let client = null
//开启订阅（登录成功后调用）
export const startSub = () => {
  if (client != null && client.connected) return
  const url = 'wss://mqtt.ye-iot.com/mqtt'
  const option = {
    //port: 8083,
    clientId: 'yeiot-data-center-backend-' + randomString(8),
    username: 'vincent',
    password: 'yeiot123',
    useSSL: true,
    rejectUnauthorized: false
  }
  client = mqtt.connect(url, option)
  client
    .on('connect', () => {
      client.subscribe('msgNotice') //订阅消息类通知主题
      client.subscribe('charge/#') //订阅充电相关主题
      client.subscribe('device/#') //订阅设备上下线相关主题
      console.log('链接mqtt成功，已订阅(notice,charge,device)相关主题')
    })
    .on('error', err => {
      console.log('链接mqtt报错', err)
      client.end()
      client.reconnect()
    })
    .on('message', (topic, message) => {
      console.log('topic', topic)
      // message is Buffer
      if (topic + '' === 'msgNotice') {
        // 消息类通知主题
        Notification({
          title: '通知',
          type: 'warning',
          message: JSON.parse(message.toString()).msg
        })
      } else if (topic.split('/')[0] == 'charge') {
        const msg = topic.split('/')[2] == 'start' ? '开始' : '结束'
        Notification({
          title: '通知',
          type: 'info',
          message: '充电订单[' + topic.split('/')[1] + ']' + msg
        })
      } 
      else if (topic.split('/')[0] == 'device') {
        /*  关闭设备上下线信息
        let msg = ''
        if (topic.split('/')[2] == 'attribute') {
          msg = '上报信息'
        } else {
          msg = topic.split('/')[2] == 'connected' ? '连线' : '离线'
        }
        Notification({
          title: '通知',
          type: 'info',
          message: '设备[' + JSON.parse(message.toString()).deviceId + ']' + msg
        })*/
      } else {
        // 设备相关主题，这里将各个模块消息写入各个模块的vuex state中，然后各个模块再getter取值
        const devCode = topic.substring(9)
        const arg = {
          devCode,
          msg: message.toString()
        }
        console.log('收到设备上传消息：', arg)
        store.commit('setDevArgsMsg', arg)
      }
    })

  Vue.prototype.$mqtt = client // 方便在vue组件中可以直接使用this.$mqtt -> client
}

// 关闭订阅（退出登录时调用）
export const closeSub = () => {
  console.log('关闭mqtt')
  client && client.end()
}



// WEBPACK FOOTER //
// ./src/mq/index.js